import { Injectable, Pipe, PipeTransform } from "@angular/core";

/**
 * Pipe regarding the transforming of a list of enum entries to a one directional list with index and value to use.
 * requires an import in the decorator.
 * usage only inside the html template. NO TS CODE.
 * for ts code useage @see EnumToIndexValueMapService
 */
@Pipe({
  name: 'enumToIndexValueMap',
  standalone: true
})
export class EnumToIndexValueMapPipe implements PipeTransform {

  public transform(data: any): { index: number; value: any; }[] {
    return EnumToIndexValueMapService.transform(data);
  }

}

/**
 * Pipe regarding the transforming of a list of enum entries to a one directional list with index and value to use.
 * no import required.
 * no instance required.
 * usage only inside the ts code. NO HTML TEMPLATE.
 * for html template usage @see EnumToIndexValueMapPipe
 */
@Injectable({
  providedIn: 'root'
})
export class EnumToIndexValueMapService {

  public static transform(data: any): { index: number; value: any; }[] {
    return Object.keys(data)
      .filter(
        e => !isNaN(Number(e)))
      .map(o => {
        return {
          index: Number(o), value: data[o]
        };
      }
      );
  }

}
